import { gunterzBold } from '@/theme/fonts';
import { Card, Group, Image, Text, rem } from '@mantine/core';
import type { ThemeCardItemType } from './casino';
export const ThemeCardItem: React.FC<ThemeCardItemType> = ({
  imgUrl,
  text
}) => {
  return <Card radius={rem(5)} bg="linear-gradient(90deg, #303942 0%, #464F59 100%)" p="sm">
      <Group wrap="nowrap" gap={10} align="center">
        <Image src={imgUrl} alt="theme-item" w={{
        base: 32,
        sm: 52
      }} h={{
        base: 32,
        sm: 52
      }} />
        <Text fz={{
        base: rem(11),
        sm: rem(13)
      }} className={gunterzBold.className} style={{
        textWrap: 'nowrap'
      }}>
          {text}
        </Text>
      </Group>
    </Card>;
};